import { QuoteBlockType } from '@/components/v3/unique/article/blocks/quote/quote'

export function provideQuoteSectionDBValueBackwardsCompatibility(
  quoteData: QuoteBlockType
) {
  const returnValue = {
    author: quoteData?.author || '',
    quote: quoteData?.quote || '',
    template: quoteData?.template || '',
    title: quoteData?.title || '',
    logo: quoteData?.logo || undefined,
  }

  switch (returnValue.template) {
    case 'light':
    case 'default':
      returnValue.template = 'light'
      break

    case 'dark':
    case 'with-background':
      returnValue.template = 'dark'
      break

    default:
      returnValue.template = 'light'
      break
  }

  return returnValue
}

export type ImageSimple = {
  id: number
  url: string
  alt: string
  videoUrl?: string
  description?: string
  credits?: string
  photographer?: { name: string; href: string }
  width?: number
  height?: number
}

export function provideImageGridSectionDBValueBackwardsCompatibility(
  block: ImageSimple[] | { images: ImageSimple[] } | undefined
): ImageSimple[] {
  if (!block) {
    return []
  }

  return 'images' in block ? block.images : block
}
